import classnames from "classnames";
import React from "react";

// tslint:disable-next-line:no-var-requires
const styles = require("./GenericButton.scss");

interface GenericButtonProps {
    readonly name?: string;
    readonly children?: string;
    readonly className?: string;
    readonly disabled?: boolean;
    readonly onClick?: (value?: any) => void;
}

export default function GenericButton({
    name,
    children,
    disabled,
    onClick,
    className
}: GenericButtonProps) {
    return (
        <button
            className={classnames(styles.button, className)}
            onClick={onClick}
            name={name}
            disabled={disabled === true}
        >
            {children}
        </button>
    );
}
